import { render, staticRenderFns } from "./DynamicPricingWidget.vue?vue&type=template&id=1fca0f0c&scoped=true"
import script from "./DynamicPricingWidget.vue?vue&type=script&lang=js"
export * from "./DynamicPricingWidget.vue?vue&type=script&lang=js"
import style0 from "./DynamicPricingWidget.vue?vue&type=style&index=0&id=1fca0f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca0f0c",
  null
  
)

export default component.exports